import { cn } from "@/core/shared/v2/lib/utils";

export function SidebarLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className={cn(["grid grid-flow-row-dense gap-8 pb-12 lg:grid-cols-[minmax(0,1fr)_400px] lg:pt-6 xl:gap-8"])}>
      {children}
    </div>
  );
}
